<!-- Hero Section -->
<section id="hero">
  <app-procurement-hero></app-procurement-hero>
</section>

<!-- Overview Section -->
<section id="overview">
  <app-procurement-overview></app-procurement-overview>
</section>

<!-- Features Section -->
<section id="features">
  <app-procurement-features></app-procurement-features>
</section>
